module.exports = __webpack_public_path__ + "static/media/107.115de70e.png";